import CreateActivityButtonsError from 'crm-activity-creator-widgets/buttons/CreateActivityButtonsError';
import ErrorBoundary from './ErrorBoundary';
import CreateActivityButtons from 'crm-activity-creator-widgets/buttons/CreateActivityButtons';
import { useHandleUpdateActivityButtons } from 'crm-activity-creator-widgets/hooks/useHandleUpdateActivityButtons';
import { useCardContextValue } from '../state/CardContext';
import { NavMarker } from 'react-rhumb';
import { useIsUngated } from 'crm-cards-sdk/hooks/useIsUngated';
import { gate } from 'hub-http/gates';
import { useUserInfo } from '../hooks/useUserInfo';
import { useActiveTaskId } from '../hooks/useActiveTaskId';
import { jsx as _jsx } from "react/jsx-runtime";
const ActivityButtonsContainer = () => {
  var _subjectPermissionsRe, _subjectPermissionsRe2;
  const {
    objectTypeId,
    objectId,
    asyncData: {
      orderedActivityButtonsResult,
      subjectPermissionsResult
    }
  } = useCardContextValue();
  const userInfo = useUserInfo();
  const {
    allActivityButtonsSorted,
    allAssociationTypesFromObjectTypeToEngagements,
    error,
    loading,
    updateQuery,
    numberVisible
  } = orderedActivityButtonsResult;
  const {
    handleUpdateActivityButtons
  } = useHandleUpdateActivityButtons({
    updateQuery
  });
  const isUngatedToCallRemote = useIsUngated(gate('Calling:Rep:CRMRecordsRemote'));
  const taskId = useActiveTaskId();
  return /*#__PURE__*/_jsx(ErrorBoundary, {
    Fallback: CreateActivityButtonsError,
    children: /*#__PURE__*/_jsx(CreateActivityButtons, {
      allActivityButtons: allActivityButtonsSorted,
      allAssociationTypesFromObjectTypeToEngagements: allAssociationTypesFromObjectTypeToEngagements,
      isError: !!error,
      isLoading: !!loading,
      objectTypeId: objectTypeId,
      onUpdate: handleUpdateActivityButtons,
      maxVisible: numberVisible,
      RhumbMarkerSuccess: /*#__PURE__*/_jsx(NavMarker, {
        name: "CREATE_ENGAGEMENT_BUTTONS"
      }),
      subjectId: String(objectId),
      enableOverflow: true,
      enableReorder: true,
      useCallingWidget: !isUngatedToCallRemote,
      taskId: taskId,
      userInfo: userInfo,
      userPermissions: {
        currentUserCanCommunicate: (_subjectPermissionsRe = (_subjectPermissionsRe2 = subjectPermissionsResult.data) === null || _subjectPermissionsRe2 === void 0 || (_subjectPermissionsRe2 = _subjectPermissionsRe2.crmObject) === null || _subjectPermissionsRe2 === void 0 || (_subjectPermissionsRe2 = _subjectPermissionsRe2.userPermissions) === null || _subjectPermissionsRe2 === void 0 ? void 0 : _subjectPermissionsRe2.currentUserCanCommunicate) !== null && _subjectPermissionsRe !== void 0 ? _subjectPermissionsRe : false
      }
    })
  });
};
export default ActivityButtonsContainer;